export const getItemName = (t, item) => t(`item.${item.id}.name`, { defaultValue: item.name });
export const getItemFact = (t, item) => t(`item.${item.id}.fact`, { defaultValue: item.fact });

const binKeyMap = {
  "recycling": "recycling",
  "general waste": "generalWaste",
  "food compost": "foodCompost",
  "yard waste": "yardWaste",
  "special programs": "specialPrograms"
};

export const getBinName = (t, bin) => {
  const key = binKeyMap[bin] || bin.replace(/\s/g, '');
  return t(`bins.${key}`, { defaultValue: bin });
};